import React, { useEffect, useState } from "react";
import { useAppSelector } from "../../../../../redux/store";
import BarekamRadio from "../../../../components/radio";
import BarekamText from "../../../../components/text";
import { UserAddress } from "../../../../shared/models/user/user-address";
import { GapContainer } from "../../../../components/card/styled";
import { StandardDialogFooter } from "../../../../components/dialogs/standard-dialog/standard-dialog";
import Message from "../../../../components/message";
import { MessageSections } from "../../../../components/message/message";
import userAddressesService from "../../../../../services/user-addresses.service";
import { DialogContent } from "@mui/material";
import { WarehouseModel } from "../../../../shared/models/order/warehouse.model";
// import allUsersService from "../../../../../services/all-users.service";
import { saveUser } from "../../personal-info/personal-info.service";
import { ARMENIA_COUNTRY_ID } from "../../../../../constants";

export const EditDefaultAddress = ({ onClose }: EditDefaultAddressProps) => {
  const { languageId } = useAppSelector((state) => state.messagesReducer);
  const [defaultAddressId, setDefaultAddressId] = useState<number>();
  const [defaultDeliveryWarehouseId, setDefaultDeliveryWarehouseId] =
    useState<number>();
  const { myAddressesData } = useAppSelector(
    (state) => state.userAddressesReducer,
  );

  const { countries } = useAppSelector((state) => state.staticDataReducer);
  const armenia = countries.find(
    (country) => country.countryId === ARMENIA_COUNTRY_ID,
  );
  const { currentUser } = useAppSelector((state) => state.currentUserReducer);

  useEffect(() => {
    setDefaultAddressId(
      myAddressesData.addresses.find((address) => address.isDefault)?.addressId,
    );
    if (currentUser && currentUser.defaultDeliveryWarehouseId) {
      setDefaultDeliveryWarehouseId(currentUser.defaultDeliveryWarehouseId);
    }
  }, []);

  async function handleClose() {
    if (currentUser) {
      const hadWarehouseAsDefault = !!currentUser.defaultDeliveryWarehouseId;
      const hadAddressAsDefault = !!myAddressesData.addresses.find(
        (address) => address.isDefault,
      );

      if (defaultDeliveryWarehouseId) {
        if (
          defaultDeliveryWarehouseId !==
          currentUser.defaultDeliveryWarehouseId &&
          currentUser.userId
        ) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          await saveUser(currentUser.userId, { defaultDeliveryWarehouseId });

          const oldDefaultAddress = myAddressesData.addresses.find(
            (address) => address.isDefault,
          );

          if (oldDefaultAddress) {
            Promise.allSettled([
              editAddress(oldDefaultAddress.addressId, { isDefault: false }),
            ]).then(() => {
              onClose(true);
            });
          } else {
            onClose(true);
          }
        }
      } else if (defaultAddressId) {
        if (hadWarehouseAsDefault && currentUser.userId) {
          Promise.allSettled([
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            await saveUser(currentUser.userId, {
              defaultDeliveryWarehouseId: null,
            }),
            editAddress(defaultAddressId, { isDefault: true }),
          ]).then(() => {
            onClose(true);
          });
        } else if (hadAddressAsDefault) {
          const oldDefaultAddress = myAddressesData.addresses.find(
            (address) => address.isDefault,
          );

          if (
            oldDefaultAddress &&
            oldDefaultAddress.addressId !== defaultAddressId
          ) {
            Promise.allSettled([
              editAddress(defaultAddressId, { isDefault: true }),
              editAddress(oldDefaultAddress.addressId, { isDefault: false }),
            ]).then(() => {
              onClose(true);
            });
          }
        }
      }
    }

    onClose(false);
  }

  async function editAddress(
    addressId: number,
    request: any,
  ): Promise<boolean> {
    try {
      try {
        const response = await userAddressesService.editAddress(
          addressId,
          request,
        );
        return response.acknowledged;
      } catch (e) {
        return false;
      }
    } catch (e) {
      return Promise.reject(false);
    }
  }

  // async function editDefaultDeliveryWarehouse(
  //   warehouseId: number,
  // ): Promise<boolean> {
  //   try {
  //     try {
  //       const response = await allUsersService.changDefaultDeliveryWarehouseId(
  //         currentUser?.userId,
  //         { defaultDeliveryWarehouseId: warehouseId },
  //       );
  //       return response ? response.acknowledged : false;
  //     } catch (e) {
  //       return false;
  //     }
  //   } catch (e) {
  //     return Promise.reject(false);
  //   }
  // }

  const AddressRow = ({
    address,
    warehouse,
  }: {
    address?: UserAddress;
    warehouse?: WarehouseModel;
  }) => {
    let addressString;
    
    if (address) {
      addressString = [
        // address.country,
        // address.city,
        address?.province?.name[languageId],
        address?.region?.name[languageId],
        address.street,
        address.building,
        address.entrance,
        address.floor,
        address.apartment,
      ]
        .filter((value) => !!value)
        .join(", ");
    }
    if (warehouse) {
      addressString = [warehouse.state, warehouse.city, warehouse.addressLine1]
        .filter((value) => !!value)
        .join(", ");
    }

    const checked = address
      ? address?.addressId === defaultAddressId
      : warehouse?.warehouseId === defaultDeliveryWarehouseId;

    return (
      <GapContainer
        onClick={() => {
          if (address) {
            setDefaultAddressId(address.addressId);
            setDefaultDeliveryWarehouseId(undefined);
          } else if (warehouse) {
            setDefaultDeliveryWarehouseId(warehouse.warehouseId);
            setDefaultAddressId(undefined);
          }
        }}
        style={{ cursor: "pointer" }}
      >
        <BarekamRadio checked={checked} />
        <BarekamText variant={"s"}>{addressString}</BarekamText>
      </GapContainer>
    );
  };

  return (
    <>
      <DialogContent>
        {armenia?.warehouse.map((warehouse) => {
          return (
            <AddressRow warehouse={warehouse} key={warehouse.warehouseId} />
          );
        })}
        {myAddressesData.addresses.map((address) => (
          <AddressRow address={address} key={address.addressId} />
        ))}
      </DialogContent>

      <StandardDialogFooter
        saveLabel={
          <Message messageKey={"save"} sectionId={MessageSections.USER} />
        }
        onSave={() => handleClose()}
        onCancel={() => onClose(false)}
      />
    </>
  );
};

interface EditDefaultAddressProps {
  onClose: (withChange: boolean) => void;
}
